module.exports = __webpack_public_path__ + "img/open-btn.c83bf050.svg";